
import {aiApi} from './ai'

export const getTTSStatusApi = aiApi.injectEndpoints({
  endpoints: (builder) => ({
    getTTSStatus: builder.query({
      
      query: ({requestId, authType, token}) => `/tts-status/${requestId}?authType=${authType}&&token=${token}`,
    }),
    

  }),
  overrideExisting: false,
})

export const { useGetTTSStatusQuery, usePrefetch } = getTTSStatusApi